import { IconDelete, IconEdit } from '@adserve/adserve-react-components';
import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { invoicingManagerMainCellStyle } from './BespokeBillingStyles';

const BespokeInvoiceManagerRow = ({ index, invoiceLine = {}, onEditInvoiceLine, onDeleteInvoiceLine, offairTypes, calcVatRate, disabled }) => {
    const { formatCurrency } = useContext(SystemSettingsContext);

    const onEditClick = () => {
        onEditInvoiceLine(invoiceLine);
    };

    const onDeleteClick = () => {
        onDeleteInvoiceLine(invoiceLine);
    };

    const calcTotals = () => {
        if (typeof calcVatRate !== 'function') {
            return {
                amount: 0,
                vat: 0,
                commission: 0
            };
        }
        const amount = parseFloat(parseFloat(invoiceLine.airtimeAmount) + parseFloat(invoiceLine.offAirAmount));
        const commission = parseFloat(
            (amount * invoiceLine.commissionRate) / 100
        );
        const netAmount = amount - commission;
        const vat = parseFloat((netAmount * invoiceLine.vatRate) / 100);

        return {
            total: parseFloat(amount - commission + vat).toFixed(2),
            vat: parseFloat(vat).toFixed(2),
            commission: parseFloat(commission).toFixed(2)
        };
    };

    const lineTotals = calcTotals();

    return (
        <tr key={`current-invoice${index}`}>
            <td style={invoicingManagerMainCellStyle(index)}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        alignItems: 'center'
                    }}
                >
                    {invoiceLine.id && <IconEdit onClick={onEditClick} height={21} width={21} disabled={disabled} />}
                </div>
            </td>

            <td style={invoicingManagerMainCellStyle(index)}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        alignItems: 'center'
                    }}
                >
                    {invoiceLine.id && (
                        <IconDelete
                            onClick={onDeleteClick}
                            height={21}
                            width={21}
                            disabled={disabled}
                        />
                    )}
                </div>
            </td>
            <td style={invoicingManagerMainCellStyle(index)}>{invoiceLine?.name}</td>
            <td align='right' style={invoicingManagerMainCellStyle(index)}>
                {(invoiceLine?.airtimeAmount || invoiceLine?.offAirAmount) && formatCurrency(invoiceLine?.airtimeAmount + invoiceLine?.offAirAmount)}
            </td>
            <td align='right' style={invoicingManagerMainCellStyle(index)}>
                {invoiceLine?.commissionRate && invoiceLine.commissionRate}
            </td>
            <td align='right' style={invoicingManagerMainCellStyle(index)}>
                {invoiceLine?.commissionRate && formatCurrency(lineTotals.commission)}
            </td>
            <td align='right' style={invoicingManagerMainCellStyle(index)}>
                {invoiceLine?.vatRate && invoiceLine.vatRate}
            </td>
            <td align='right' style={invoicingManagerMainCellStyle(index)}>
                {invoiceLine?.vatRate && formatCurrency(lineTotals.vat)}
            </td>
            <td
                align='right'
                style={{
                    ...invoicingManagerMainCellStyle(index),
                    paddingRight: 29
                }}
            >
                {(invoiceLine?.airtimeAmount || invoiceLine?.offAirAmount) && formatCurrency(lineTotals.total)}
            </td>
        </tr>
    );
};

export default BespokeInvoiceManagerRow;
